"use strict";

var PAGESIZE = 20;

require("./CompanyPublicationActivity.js");
require("./CompanyPublicationActivityTranslator.js");

function EsignActivity(CompanyPublicationActivity, CompanyPublicationActivityTranslator, $stateParams) {
  return {
    restrict:    "A",
    templateUrl: "partials/company/publications/esign-activity.html",
    scope: {
      source:   "=esignActivity",
      user:     "=user"
    },
    link: function($scope) {
      $scope.loading    = false;
      $scope.page       = 0;
      $scope.activity   = [];
      $scope.PAGESIZE   = PAGESIZE;
      
      $scope.loadData = function loadData() {
        $scope.loading = true;
        $scope.page    = $scope.page > 0 ? $scope.page : 0;

        /* TODO: That toUpperCase() should be removed
         * and all constants should be uppercase instead.
         */
        $scope.source.next($scope.page * PAGESIZE, PAGESIZE + 1, ['AUDITLOG']).then(function(activity) {
          $scope.hasNextPage = activity.length > PAGESIZE;
          $scope.loading     = false;
          $scope.activity    = activity.map(CompanyPublicationActivityTranslator).sort(function(a, b) {
            if (a.user && a.user.name === "A L L") {
              return -1;
            }
            return 0;
          });
        });
      };
      
      if( ! $scope.types) {
        $scope.types = [];
      }

      $scope.$on('notification', function(){
        $scope.source = new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
        $scope.page = 0;
        $scope.loading = true;
        $scope.loadData();
      });
      
      $scope.loadData();
    }
  };
}

angular.module("dokiv")
  .directive("esignActivity", ["CompanyPublicationActivity", "CompanyPublicationActivityTranslator", "$stateParams", EsignActivity]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyEsignActivityDirective.js
// module id = 371
// module chunks = 0